import { useMatchRoute } from "@tanstack/react-router";

import { useNavGroups, type NavGroup, type SubLink } from "./navConfig";

interface ActiveNavState {
  activeGroup: NavGroup | null;
  activeSubLink: SubLink | null;
}

function getRouteMatchPath(route: SubLink["route"]): string {
  const candidates = [route.id, route.to];
  return (
    candidates.find((value): value is string => typeof value === "string") ?? ""
  );
}

function sortSubLinksBySpecificity(subLinks: SubLink[]): SubLink[] {
  return [...subLinks].sort(
    (a, b) =>
      getRouteMatchPath(b.route).length - getRouteMatchPath(a.route).length,
  );
}

export function useActiveNavGroup(): ActiveNavState {
  const matchRoute = useMatchRoute();
  const navGroups = useNavGroups();

  for (const group of navGroups) {
    if (group.subLinks) {
      for (const subLink of sortSubLinksBySpecificity(group.subLinks)) {
        if (
          matchRoute({
            to: subLink.route.to,
            params: subLink.params ?? {},
            fuzzy: subLink.params ? false : true,
          })
        ) {
          return { activeGroup: group, activeSubLink: subLink };
        }
      }
    }

    if (
      matchRoute({
        to: group.defaultRoute.to,
        params: {},
        fuzzy: true,
      })
    ) {
      return { activeGroup: group, activeSubLink: null };
    }
  }

  return { activeGroup: null, activeSubLink: null };
}
